// extracted by css-extract-rspack-plugin
export default {"cls1":"ProfileDropdown-cls1_31N","cls2":"ProfileDropdown-cls2_Kbn ProfileDropdown-cls1_31N"};